import React from 'react';
import { Card } from '../components/ui';

export default function ExamReport({ examsAll, selectedExamId, setSelectedExamId, formatDate }) {
  if (!examsAll || examsAll.length === 0) return null;
  const selectedExam = (examsAll && examsAll.length)
    ? (examsAll.find(e => String(e.id) === String(selectedExamId)) || examsAll[0])
    : null;

  const StatPill = ({ label, value, strong }) => (
    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
      <div style={{ fontSize:12, color:'#64748b' }}>{label}</div>
      <span style={{ padding:'6px 10px', borderRadius:999, border:'1px solid #e5e7eb', fontSize:13, color: strong ? '#0F1E56' : '#334155', background:'#f8fafc', fontWeight: strong ? 700 : 500 }}>
        {value ?? '-'}
      </span>
    </div>
  );

  const SubjectRow = ({ name, correct, wrong, net }) => {
    const palette = ['#3B82F6','#10B981','#F59E0B','#EF4444','#8B5CF6','#06B6D4','#84CC16','#EC4899','#F97316','#22C55E'];
    const idx = Array.from(name || '').reduce((a,c)=>a+c.charCodeAt(0),0) % palette.length;
    const accent = palette[idx];
    return (
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', background:'#fff', border:'1px solid #eef2f7', borderRadius:10, padding:'8px 10px', gap:8 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, minWidth:0, flex:'1 1 140px' }}>
          <span style={{ width:8, height:8, borderRadius:'50%', background:accent, display:'inline-block' }} />
          <div style={{ fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{name}</div>
        </div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:6, alignItems:'center', justifyContent:'flex-end', flex:'1 1 190px' }}>
          <span style={{ padding:'4px 8px', borderRadius:999, border:'1px solid #e5e7eb', fontSize:12, color:'#334155', background:'#f8fafc', textAlign:'center', whiteSpace:'nowrap' }}>{correct} D</span>
          <span style={{ padding:'4px 8px', borderRadius:999, border:'1px solid #e5e7eb', fontSize:12, color:'#334155', background:'#f8fafc', textAlign:'center', whiteSpace:'nowrap' }}>{wrong} Y</span>
          <span style={{ padding:'4px 8px', borderRadius:999, border:'1px solid #e5e7eb', fontSize:12, color:'#0F1E56', background:'#f8fafc', fontWeight:700, textAlign:'center', whiteSpace:'nowrap' }}>Net {net != null ? Number(net).toFixed(2) : '-'}</span>
        </div>
      </div>
    );
  };

  return (
    <Card title="Sınav Karnesi">
      <div style={{ marginBottom:10 }}>
        <label htmlFor="exam-select" style={{ fontSize:12, color:'#64748b', display:'block', marginBottom:4 }}>Sınav seç</label>
        <select
          id="exam-select"
          value={selectedExamId}
          onChange={(e) => setSelectedExamId(e.target.value)}
          style={{ width:'100%', padding:10, borderRadius:12, border:'1px solid #e5e7eb', background:'#fff', boxShadow:'0 1px 4px rgba(0,0,0,0.02)' }}
        >
          {examsAll.map(ex => (
            <option key={ex.id} value={ex.id}>{formatDate(ex.date)}{ex.total_score != null ? ` • ${ex.total_score}` : ''}</option>
          ))}
        </select>
      </div>
      {selectedExam && (
        <>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(2, minmax(0, 1fr))', gap:8, marginBottom:10 }}>
            <StatPill label="Sınav Tarihi" value={formatDate(selectedExam.date)} />
            <StatPill label="Toplam Puan" value={selectedExam.total_score != null ? Number(selectedExam.total_score).toFixed(2) : '-'} strong />
            <StatPill label="Toplam Net" value={selectedExam.total_net != null ? Number(selectedExam.total_net).toFixed(2) : '-'} strong />
          </div>
          {selectedExam.subjects && selectedExam.subjects.length > 0 && (
            <div>
              <div style={{ fontSize:12, color:'#64748b', margin:'2px 0 6px 2px' }}>Ders Bazında</div>
              <div style={{ display:'grid', gap:8 }}>
                {selectedExam.subjects.map((s,i) => (
                  <SubjectRow key={i} name={s.name} correct={s.correct} wrong={s.wrong} net={s.net} />
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </Card>
  );
}
